export const distanceBodyCoding = {
    heading: "Distance Body Coding",
    content: [
        'All Body Coding sessions are done remotely, allowing healing to take place no matter where you are in the world.',
        'Through focused intention and energy connection, remote Body Coding is just as effective as in-person sessions — offering deep transformation and energetic realignment from the comfort of your home.',
    ],
}